export var TimePickerTab;
(function (TimePickerTab) {
    TimePickerTab["Rolling"] = "Rolling";
    TimePickerTab["Periods"] = "Periods";
    TimePickerTab["Calendar"] = "Calendar";
})(TimePickerTab || (TimePickerTab = {}));
export function daysToRollingPeriod(days) {
    const minutes = days * 60 * 24;
    return {
        period: `${minutes}m`,
        ms: minutes * 60 * 1000,
    };
}
export function hoursToRollingPeriod(hours) {
    const minutes = hours * 60;
    return {
        period: `${minutes}m`,
        ms: minutes * 60 * 1000,
    };
}
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;
// The `ms` parameter is still used on the view page to pass the time range around the app
// this needs to be updated at some point to use range, but it will need to be after kpi support
export function getHourPeriods() {
    return [
        { label: '1 hour', period: '1h', ms: HOUR },
        { label: '3 hours', period: '3h', ms: HOUR * 3 },
        { label: '6 hours', period: '6h', ms: HOUR * 6 },
        { label: '12 hours', period: '12h', ms: HOUR * 12 },
    ];
}
export function getDayPeriods() {
    return [
        { label: '1 day', period: '1d', ms: DAY },
        { label: '3 days', period: '3d', ms: DAY * 3 },
        { label: '7 days', period: '7d', ms: DAY * 7 },
        { label: '14 days', period: '14d', ms: DAY * 14 },
    ];
}
export function getFurtherBackPeriods() {
    return [
        { label: '30 days', period: '30d', ms: DAY * 30 },
        { label: '90 days', period: '90d', ms: DAY * 90 },
        { label: '180 days', period: '180d', ms: DAY * 180 },
        { label: '1 year', period: '1y', ms: DAY * 365 },
    ];
}
export function getRollingPeriodFromMs(ms) {
    return [...getHourPeriods(), ...getDayPeriods(), ...getFurtherBackPeriods()]
        .find((p) => p.ms === ms);
}
